import { defineStore } from 'pinia'
import {services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useBillingStore = defineStore('billingStore', {
  state:() => ({
		creditBalanceHistoryList:[],
		creditBalanceHistoryPagination:{}
  }),
    actions : {
			// async getCreditBalanceHistoryList(params){
			// 	try{
			// 		const res = await axios.get(`${services.billing}credit-balances?${params.toString()}`, { headers: getHeader() });
			// 		// console.log(res);
			// 		if(!_gHlp.isEmpty(res.data.content)){
			// 			this.creditBalanceHistoryList = res.data.content;
			// 			this.creditBalanceHistoryPagination = res.data.pagination;
			// 		}else{
			// 			this.creditBalanceHistoryList = [];
			// 			this.creditBalanceHistoryPagination = {
			// 				limit:20,
			// 				page:1,
			// 				total_data:0,
			// 				total_page:1
			// 			};
			// 		}
			// 	}catch(e){
			// 		this.creditBalanceHistoryList = []

			// 		console.log(e);
			// 	}
			// }
      async getCreditBalanceHistoryList(params){
      try{
        const res = await axios.get(`${services.billing}credit-balances?${params.toString()}`, { headers: getHeader() });
        
        if(!_gHlp.isEmpty(res.data.content)){
        
            const getDateValue = (item) => {
                const d = item.cbh_transaction_date || item.cbh_created_date || item.cbh_created_at || null;
                const parsed = d ? new Date(d) : new Date(0);
                return parsed;
            };

            const sortedData = [...res.data.content].sort((a, b) => {
                const dateA = getDateValue(a);
                const dateB = getDateValue(b);
                return dateB - dateA; 
            });

            this.creditBalanceHistoryList = sortedData;
            this.creditBalanceHistoryPagination = res.data.pagination;
            } else {
                this.creditBalanceHistoryList = [];
                this.creditBalanceHistoryPagination = {
                    limit:20,
                    page:1,
                    total_data:0,
                    total_page:1
                };
            }
          } catch(e) {
              this.creditBalanceHistoryList = [];
              console.log(e);
          }
       }
    }
})